// Copyright (C) 2012-present, The Authors. This program is free software: you can redistribute it and/or  modify it under the terms of the GNU Affero General Public License, version 3, as published by the Free Software Foundation. This program is distributed in the hope that it will be useful, but WITHOUT ANY WARRANTY; without even the implied warranty of MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the GNU Affero General Public License for more details. You should have received a copy of the GNU Affero General Public License along with this program.  If not, see <http://www.gnu.org/licenses/>.

import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { Box, Heading, Text } from 'theme-ui'

import Spinner from '../framework/Spinner'
import strings from '../../strings/strings'
import { useUser } from '../../util/auth'
import { populateUserStore } from '../../actions'
import PolisNet from '../../util/net'

const OrgInvite = () => {
  const userContext = useUser()
  const [searchParams] = useSearchParams()
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const token = searchParams.get('token')
  const [state, setState] = useState('pending') // pending | accepting | done | error

  useEffect(() => {
    const accept = async () => {
      if (!token) {
        setState('error')
        return
      }
      if (!userContext?.user?.uid) return // wait until logged in
      setState('accepting')
      try {
        await PolisNet.polisPost('/api/v3/organizations/invites/accept', {
          token
        })
        dispatch(populateUserStore())
        setState('done')
        setTimeout(() => navigate('/account'), 1500)
      } catch (e) {
        setState('error')
      }
    }
    accept()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userContext?.user?.uid, token])

  return (
    <Box sx={{ maxWidth: '640px', p: [3] }}>
      <Heading as="h3" sx={{ mb: [3] }}>
        {strings('pg_account_invite_accept')}
      </Heading>
      {!userContext?.user?.uid ? <Spinner /> : null}
      {state === 'accepting' ? (
        <Text>{strings('pg_account_invite_accepting')}</Text>
      ) : null}
      {state === 'done' ? (
        <Text sx={{ color: 'primary' }}>
          {strings('pg_account_invite_accepted')}
        </Text>
      ) : null}
      {state === 'error' ? (
        <Text sx={{ color: 'red' }}>
          {strings('pg_account_invite_accept_error')}
        </Text>
      ) : null}
    </Box>
  )
}

export default OrgInvite
